export default class Duration {
    /**
     * Duration time in milliseconds
     */
    public static readonly Slow: number = 600;

    /**
     * Duration time in milliseconds
     */
    public static readonly Default: number = 400;

    /**
     * Duration time in milliseconds
     */
    public static readonly Fast: number = 200;
}
